exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link {\n  color: black; }\n\n.actives {\n  background: #426e86;\n  color: white; }\n\n.selected-tab-0 md-ink-bar {\n  background-color: red; }\n\n.selected-tab-1 md-ink-bar {\n  background-color: #426e86; }\n\n.selected-tab-2 md-ink-bar {\n  background-color: green; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/comment-window/comment-window.component.scss
// module id = ../../../../../src/app/comment-window/comment-window.component.scss
// module chunks = main